<template>
  <div>
    <header>
      <div class="bc">
        <div class="header-img">
          <label>
            <input
              type="file"
              @change="upLoadImg"
              name="flieupload"
              id="flieupload"
              ref="flieupload"
            >
            <img
              :src="saveData.HeadImageUrl?saveData.HeadImageUrl+'?x-oss-process=image/resize,m_fill,h_170,w_170':(saveData.HeadImage?saveData.HeadImage+'?x-oss-process=image/resize,m_fill,h_170,w_170':defaultImg)"
              :onerror="defaultImg"
              alt
            >
          </label>
        </div>
        <div class="label clearfix">
          <div class="title">姓名</div>
          <div class="input">
            <input type="text" placeholder="请输入姓名" v-model="saveData.RealName">
          </div>
        </div>
        <div class="label clearfix mat-10">
          <div class="title">出生年月</div>
          <div class="select">
            <yd-datetime type="date" v-model="saveData.Birthday" start-year="1900" slot="right"></yd-datetime>
            <i></i>
          </div>
        </div>
        <div class="label clearfix">
          <div class="title">性别</div>
          <div class="select">
            <select v-model="saveData.Sex">
              <option value="0">男</option>
              <option value="1">女</option>
            </select>
            <i></i>
          </div>
        </div>
        <div class="label clearfix">
          <div class="title">联系电话</div>
          <div class="input">
            <span>{{saveData.MobileTelePhone}}</span>
          </div>
        </div>
        <div class="label clearfix">
          <div class="title">联系地址</div>
          <div class="input">
            <input type="text" placeholder="请输入联系地址" v-model="saveData.Address">
          </div>
        </div>
        <div class="label clearfix">
          <div class="title">邮箱</div>
          <div class="input">
            <input type="text" placeholder="请输入邮箱" v-model="saveData.Email">
          </div>
        </div>
        <button class="btn-main btn-save" @click="submit">保存修改</button>
        <footer-logo></footer-logo>
      </div>
    </header>
  </div>
</template>

<script>
import footerLogo from '@/components/footerLogo.vue'
export default {
  components: {
    'footer-logo': footerLogo
  },
  data() {
    return {
      saveData: {
        isloading: true,
        Birthday: '1990-01-01',
        HeadImageUrl: ''
      },
      defaultImg: 'this.src="' + require('@/assets/images/defaultImg.png') + '"'
    }
  },
  created() {
    this.getuserData()
  },
  methods: {
    getuserData() {
      var token = window.localStorage.getItem('ei_token')
      this.$fetch('/api/Membership/Info', {
        token: token
      }).then(result => {
        this.saveData.isloading = false
        let userInfo = result
        this.saveData.HeadImageUrl = userInfo.HeadImageUrl
        this.saveData.NickName = userInfo.NickName
        this.saveData.RealName = userInfo.RealName
        this.saveData.Sex = userInfo.Sex
        this.saveData.MobileTelePhone = userInfo.MobileTelePhone
        this.saveData.WeiXinCode = userInfo.WeiXinCode
        this.saveData.Birthday = userInfo.Birthday
        this.saveData.Address = userInfo.Address
        this.saveData.Email = userInfo.Email
      })
    },
    submit() {
      var reg = 11 && /^((13|14|15|17|18)[0-9]{1}\d{8})$/
      if (this.saveData.NickName === '') {
        this.$dialog.toast({
          mes: '请输入姓名',
          timeout: 1500
        })
        return
      }

      this.$post('/api/Membership/Update', this.saveData)
        .then(result => {
          this.$dialog.toast({
            mes: '保存成功',
            timeout: 1500,
            icon: 'success'
          })
          this.$router.push({
            name: 'mine'
          })
        })
        .catch(result => {
          this.$dialog.toast({
            mes: result.Error.Message,
            timeout: 1500,
            icon: 'error'
          })
        })
    },
    //      上传头像
    upLoadImg(el) {
      var _this = this
      var files = el.target.files
      var choosedFilesCount = files.length
      if (choosedFilesCount > 0) {
        var file = files[0]
        var formData = new FormData()
        formData.append('file', file, file.name)
        this.$postImg('/api/Common/UploadFile', formData)
          .then(function(result) {
            _this.saveData.HeadImageUrl = result
          })
          .catch(function(result) {})
      }
    }
  }
}
</script>

<style lang="less" scoped>
header {
  width: 100%;
  height: 320 / @rem-size;
  background: url('../../assets/images/ticket-bc.png');
  background-size: 100% 100%;
  position: relative;
  padding: 0 24 / @rem-size;

  .bc {
    width: 702 / @rem-size;
    height: auto;
    padding: 90 / @rem-size 36 / @rem-size 0;
    background: #fff;
    border-radius: 8 / @rem-size;
    position: absolute;
    top: 136 / @rem-size;
    left: 0;
    right: 0;
    margin: auto;

    .header-img {
      width: 144 / @rem-size;
      height: 144 / @rem-size;
      border: 6 / @rem-size solid #fff;
      border-radius: 50%;
      overflow: hidden;
      position: absolute;
      top: -75 / @rem-size;
      left: 0;
      right: 0;
      margin: auto;

      input[type='file'] {
        display: none;
      }

      img {
        width: 100%;
        height: 100%;
      }
    }
  }
}

.label {
  width: 100%;
  height: 89 / @rem-size;
  display: flex;

  .title {
    float: left;
    line-height: 89 / @rem-size;
    width: 120 / @rem-size;
    text-align: right;
    font-size: 28 / @rem-size;
    color: #999;
  }

  .select {
    width: 470 / @rem-size;
    height: 89 / @rem-size;
    float: right;
    border-bottom: 1px solid #e5e5e5;
    margin-left: 45 / @rem-size;
    font-size: 30 / @rem-size;
    position: relative;

    select {
      width: 100%;
      height: 100%;
      font-size: 30 / @rem-size;
    }

    i {
      display: block;
      width: 16 / @rem-size;
      height: 12 / @rem-size;
      background: url('../../assets/images/pull-icon.png');
      background-size: 100% 100%;
      position: absolute;
      top: 0;
      bottom: 0;
      right: 0;
      margin: auto;
    }
  }

  .input {
    width: 470 / @rem-size;
    height: 89 / @rem-size;
    float: right;
    border-bottom: 1px solid #e5e5e5;
    margin-left: 45 / @rem-size;
    font-size: 30 / @rem-size;

    span {
      line-height: 89 / @rem-size;
      padding-left: 10 / @rem-size;
      color: #333;
      display: block;
    }

    input {
      width: 100%;
      height: 100%;
      font-size: 30 / @rem-size;
      padding-left: 10 / @rem-size;
      color: #333;
    }
  }
}

.mat-10 {
  margin-top: 10 / @rem-size;
}

.yd-datetime-input {
  line-height: 0.89rem;
}

.btn-save {
  width: 360 / @rem-size;
  height: 80 / @rem-size;
  border-radius: 8 / @rem-size;
  font-size: 36 / @rem-size;
  display: block;
  margin: 50 / @rem-size auto;
}
</style>
